import { useState } from "react";
import { Download } from "lucide-react";
import { API } from "../../lib/api";
import { useFetch } from "../../lib/useData";
import { PageTitle, TableWrap, Btn, Select } from "../../components/admin/ui";
const PAGE_SIZES = [10, 50, 100, 500, 1000];
const TYPES = [
  { value: "booking", label: "Booking Report" },
  { value: "date-wise", label: "Date-wise Report" },
  { value: "seva-wise", label: "Seva-wise Report" },
];

export default function Reports() {
  const [type, setType] = useState("booking");
  const { data } = useFetch(`/admin/reports/${type}`, [type]);
  const rows = data?.rows || [];
  const [pageSize, setPageSize] = useState(10);
const [page, setPage] = useState(1);

const total = rows.length;
const totalPages = Math.max(1, Math.ceil(total / pageSize));
const currentPage = Math.min(page, totalPages);
const start = (currentPage - 1) * pageSize;
const pagedRows = rows.slice(start, start + pageSize);

  const cols = {
    booking: [["booking_id", "Booking ID"], ["devotee_name", "Devotee"], ["seva_name", "Seva"], ["date", "Date"], ["amount", "Amount"], ["payment_status", "Payment"], ["booking_status", "Status"]],
    "date-wise": [["date", "Date"], ["bookings", "Bookings"], ["revenue", "Revenue"]],
    "seva-wise": [["seva_name", "Seva"], ["total", "Total"], ["revenue", "Revenue"], ["cancelled", "Cancelled"], ["refunded", "Refunded"]],
  }[type];

  return (
    <div>
      <PageTitle title="Reports" desc="Booking, date-wise and seva-wise analytics">
        <a href={`${API}/admin/reports/${type}/export`} download>
          <Btn variant="outline" testid="report-export"><Download className="w-4 h-4" /> Export CSV</Btn>
        </a>
      </PageTitle>
      <div className="w-64 mb-4"><Select value={type} onChange={(v) => { setType(v); setPage(1); }} options={TYPES} testid="report-type" /></div>
      <TableWrap>
        <thead className="bg-slate-800 text-slate-400"><tr>{cols.map(([, l]) => <th key={l} className="text-left px-4 py-3">{l}</th>)}</tr></thead>
        <tbody className="divide-y divide-slate-700" data-testid="report-table">
{pagedRows.map((r, i) => (
              <tr key={i} className="hover:bg-slate-800/50">
              {cols.map(([k]) => <td key={k} className="px-4 py-3 text-slate-200">{k.includes("revenue") || k === "refunded" || k === "amount" ? `₹${r[k] || 0}` : String(r[k] ?? "—")}</td>)}
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={cols.length} className="px-4 py-8 text-center text-slate-500">No data</td></tr>}
        </tbody>
      </TableWrap>
      {total > 0 && (
  <div className="flex flex-wrap items-center justify-between gap-3 mt-4 text-sm text-slate-300">
    <div className="flex items-center gap-2">
      <span>Show</span>
      <select
        value={pageSize}
        onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
        className="bg-slate-800 border border-slate-700 rounded-lg px-2 py-1.5 text-slate-200"
        data-testid="report-page-size"
      >
        {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      <span>per page</span>
    </div>

    <span className="text-slate-400">
      {start + 1}–{Math.min(start + pageSize, total)} of {total}
    </span>

    <div className="flex items-center gap-2">
      <button
        onClick={() => setPage(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1.5 rounded-lg bg-slate-800 border border-slate-700 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >Prev</button>
      <span>{currentPage} / {totalPages}</span>
      <button
        onClick={() => setPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1.5 rounded-lg bg-slate-800 border border-slate-700 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >Next</button>
    </div>
  </div>
)}
    </div>
  );
}
